import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';

export async function fetchBranchOffices({ commit, state }) {
    await $http.get('/api/sedes')
        .then((response) => {
            commit('setBranchOffices', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
            commit('BranchOfficeError', error.message)
        })
}

//Obtener los terceros
export async function fetchWarehouses({ commit, state }, requestParameters = { params: state.params }) {
  
    await $http
      .get("/api/bodegas-sedes/", requestParameters)
      .then(response => {
        commit("setWarehouses", response.data);
      })
      .catch(error => {
        let data = error.response.data;
        Notification.error({
          title: "Error!",
          message: data.message,
          type: "error",
          duration: 1500,
          customClass: "notification-box"
        });
      });
  }
  

// obtener Data libro Contable
export async function fetchReportConciliation({commit, state}) {
    //console.log(state.params);
    await $http.get('/api/conciliacion-saldos', { params : state.params})
        .then((response) => {
            //console.log(response.data.data);
            commit('setconciation_balances', response.data);
            state.loading.module = false;
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}


// WEBPACK FOOTER //
// ./src/modules/conciliation-balances/actions.js